<template>
  <button
    v-if="isNew"
    :class="['email_nav--item new_email flex', {'active': isActive}]"
    @click="$emit('click')"
  >
    <span class="email_nav--item--content flex-grow">
      <span class="email_nav--item--subject">New Email</span>
    </span>
  </button>

  <button
    v-else
    :class="['email_nav--item', {'active': isActive}]"
    @click="$emit('click')"
  >
    <app-avatar
      v-if="displayUserAvatar"
      :size="18"
      :user-id="email.createdBy.id"
      position="is-right"
    ></app-avatar>

    <span class="email_nav--item--content flex-grow">
      <span class="flex flex-between mb-25">
        <template v-if="email.error_message">
          <span class="email_nav--item--error">{{ email.error_message }}</span>
        </template>
        <template v-else>
          <span class="email_nav--item--date">
            <small v-if="isScheduled">(scheduled)</small>
            {{ date }}
            <span v-if="emailStatus && !isScheduled">{{ emailStatus }}</span>
          </span>
          <span
            v-if="isScheduled"
            @click="cancelScheduledEmail"
            class="email_nav--item--unscheduled"
          >DON'T SEND</span>
        </template>
      </span>
      <span class="email_nav--item--subject">{{ email.email_subject }}</span>
    </span>
  </button>
</template>

<script>
import {ENUMS} from "../../../services/enums"
import {MODELS} from "../../../services/models"
import dates from "../../../services/dates";

export default {
  name: "EmailListItem",
  props: {
    email: {
      type: Object,
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isScheduled() {
      return this.email.is_scheduled;
    },
    displayUserAvatar() {
      return this.email !== undefined
        && this.email.communication_direction === ENUMS.CommunicationDirectionEnum.Outbound.value
        && this.email.createdBy.class_name === MODELS.User.class_name;
    },
    date() {
      if(this.email !== undefined) {
        if (this.isScheduled) {
          return dates.formatAsDateTime(this.email.scheduled_at)
        }

        return dates.formatAsDateTime(this.email.created_at)
      }
    },
    emailStatus() {
      // Only return a status if integration is mailgun
      if (this.$store.getters.market.email_integration_type === ENUMS.EmailIntegrationTypeEnum.Gmail.value) {
        return null;
      }

      // Only return a status if the email is outbound
      if(this.email.communication_direction === ENUMS.CommunicationDirectionEnum.Inbound.value) {
        return null;
      }

      // If email is opened and clicked
      if(this.email.clicked) {
        return 'clicked';
      }
      // If email is opened but not clicked
      else if(this.email.opened) {
        return "opened";
      }

      return "unopened";
    }
  },
  methods: {
    cancelScheduledEmail() {
      this.$utils.confirm(
        `Are you sure you want to <strong>cancel</strong> the scheduled email?`,
        'Cancel Scheduled Email'
      )
        .then(() => {
          this.$api.communicationLogs.cancelSchedule(this.email.id).then(res => {})
        });
    }
  },
}
</script>

<style
  lang="scss"
  scoped
>
@import "../../../styles/variables/variables";

.email_nav--item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 4px;
  border-left: 4px solid transparent;
  border-bottom: 1px solid $borderDark;
  text-align: left;

  &.active,
  &:hover {
    background-color: $background;
  }

  &.active {
    border-left-color: $primary;
  }

  &--content {
    padding: 0 6px;
    font-weight: normal;
  }

  &--date {
    display: block;
    font-size: 0.75rem;
    color: $text-muted;

    small {
      color: $text;
    }

    span {
      margin-left: 4px;
      padding-left: 6px;
      border-left: 1px solid $text-muted;
      letter-spacing: 0.5px;
    }
  }

  &--unscheduled {
    font-size: 0.625rem;
    color: $link;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }

  &--error {
    display: block;
    font-size: 0.75rem;
    color: $danger;
  }

  &--subject {
    display: block;
    margin-top: 2px;
    font-size: 1rem;
  }
}
</style>
